import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import Section from 'components/common/Section';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import { numberWithComma } from 'utils/number';
import DietStatisticsChart from 'components/charts/DietStatisticsChart';
import DialogButton from 'components/common/DialogButton';
import ExerciseDialog from 'components/dialogs/ExerciseDialog';
import React from 'react';

import DietStatisticsTable from './DietStatisticsTable';

export default function DietStatistics(props) {
  const {
    category,
    mealData,
    duration,
    ...rest
  } = props;

  return (
    <Section
      {...ex('DietStatistics', rest)}
      {...{
        caption: T('일별 통계'),
        direction: DIRECTION_VERTICAL,
      }}
    >
      <DietStatisticsChart {...{ duration }} />
      <DietStatisticsTable />
    </Section>
  );
}
